import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, InputGroup, InputGroupText, Label, Modal, ModalBody, Spinner } from 'reactstrap';

import { CANCELLED_WITH_VENDOR, CANCELLED_WITH_VENDOR_EMPTY, UPLOAD_CANCELATION_FILE } from '../../../../../../../store/actions';

const hiddenInputStyle = {
  display: 'none',
};

const CancelledWithVendor = ({ onClose, currentSelectedBooking }) => {
  const dispatch = useDispatch();
  const fileRef = useRef(null);

  const [fileName, setFileName] = useState('');
  const [fileUrl, setFileUrl] = useState(null);

  const { uploadPriceFile, uploadPriceFileloading, cancelWithVendor, cancelWithVendorloading } = useSelector(state => ({
    uploadPriceFile: state?.UploadCancelationFile?.data,
    uploadPriceFileloading: state?.UploadCancelationFile?.loading,
    cancelWithVendor: state?.CancelledWithVendor?.data,
    cancelWithVendorloading: state?.CancelledWithVendor?.loading,
  }));

  console.log('uploadPriceFile', uploadPriceFile);

  // ✅ when API returns uploaded file URL, save it
  useEffect(() => {
    if (uploadPriceFile) {
      setFileUrl(uploadPriceFile?.results?.[0]?.file_url || null);
    }
  }, [uploadPriceFile]);

  const handlePick = () => fileRef.current?.click();

  const handleChange = e => {
    const file = e.target.files?.[0];
    if (!file) return;

    setFileName(file.name);

    const formData = new FormData();
    formData.append('files', file);
    formData.append('purpose', 'CANCELLED_WITH_VENDOR');

    dispatch({
      type: UPLOAD_CANCELATION_FILE,
      payload: { data: formData },
    });
  };

  const handleRemove = () => {
    setFileName('');
    setFileUrl(null);
    fileRef.current.value = ''; // reset input
  };

  const handleSubmit = () => {
    dispatch({
      type: CANCELLED_WITH_VENDOR,
      payload: {
        data: { files: fileUrl ? [fileUrl] : [], booking_id: currentSelectedBooking?.id },
      },
    });
  };

  useEffect(() => {
    if (cancelWithVendor) {
      dispatch({ type: CANCELLED_WITH_VENDOR_EMPTY });
      onClose();
    }
    return () => {
      dispatch({ type: CANCELLED_WITH_VENDOR_EMPTY });
    };
  }, [cancelWithVendor]);

  return (
    <Modal isOpen centered size="sm">
      <ModalBody>
        <p className="fs-14 text-center" style={{ color: '#001849' }}>
          Are you sure you want to mark this booking cancelled processed?
        </p>

        <div className="mb-3">
          <Label className="form-label">
            Attach Screenshot <span className="text-muted">(Optional)</span>
          </Label>

          {/* Upload UI */}
          {!fileUrl ? (
            <InputGroup>
              <InputGroupText role="button" onClick={handlePick} className="select-image-pill w-100">
                {uploadPriceFileloading ? <Spinner size="sm" /> : fileName || 'Select Image'}
              </InputGroupText>
            </InputGroup>
          ) : (
            <div className="d-flex justify-content-between align-items-center border p-2 rounded">
              <span className="text-truncate">{fileName}</span>
              <Button color="danger" size="sm" onClick={handleRemove}>
                Remove
              </Button>
            </div>
          )}

          {/* Hidden input */}
          <input type="file" accept="image/*" ref={fileRef} onChange={handleChange} style={hiddenInputStyle} />
        </div>
      </ModalBody>

      <div className="d-flex justify-content-center mb-4 gap-3">
        {!cancelWithVendorloading ? (
          <Button color="primary" style={{ fontSize: '14px', width: '100px', borderRadius: '10px' }} onClick={handleSubmit}>
            Yes
          </Button>
        ) : (
          <Button color="primary" style={{ fontSize: '14px', width: '100px', borderRadius: '10px' }}>
            <Spinner size="sm" />
          </Button>
        )}

        <Button
          color="white"
          style={{
            fontSize: '14px',
            width: '100px',
            borderRadius: '10px',
            border: '1px solid #401589',
          }}
          onClick={onClose}
        >
          No
        </Button>
      </div>
    </Modal>
  );
};

export default CancelledWithVendor;
